export class EmployeeNotesDto {
  public EmployeeID: string;
  public EmployeeNotes: string;
  public DateModified: string;
  public ModifiedBy: string;
}
